import { useQuery } from '@tanstack/react-query';
import { fetchMyFestivalMaps } from '../../api/festivalMap';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

/**
 * The caller's map-having events for the Maps index, in the RPC's order
 * (soonest-upcoming first, then past, most recent first). Grouping into
 * Upcoming / Past is presentation over that order; never re-sort.
 */
export function useMyFestivalMaps(userId) {
  return useQuery({
    queryKey: queryKeys.festivalMap.mine(userId),
    queryFn: fetchMyFestivalMaps,
    enabled: Boolean(userId),
    staleTime: STALE.semiStatic,
  });
}
